import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { EmptyState } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledEnrichmentEmptyStateIcon = styled(SWReactIcons)`
    margin-bottom: 12px;

    svg {
        width: 150px;
        height: 90px;
    }
`;

export const StyledInnerContentWrapper = styled(Flex)`
    align-items: center;
    justify-content: center;
    gap: 12px;
`;

export const StyledEmptyState = styled(EmptyState)`
    max-width: 392px;
    text-align: center;
    margin: 0 auto;
    height: auto;
    min-height: 300px;
`;
